import React, { FunctionComponent } from "react";

const EmailActionUnreadIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/emails/email-actions/email-action-unread
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.500 4.750 L22.500 4.750 L22.500 19.750 L1.500 19.750 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M22.161,5.3l-8.144,6.264a3.308,3.308,0,0,1-4.034,0L1.839,5.3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default EmailActionUnreadIcon;
